export type DelegatedAccessLevel = 'view' | 'edit'

export const DELEGATED_ACCESS_LEVEL_LABELS: Record<DelegatedAccessLevel, string> = {
	view: 'View only',
	edit: 'View and edit',
}

export const formatDelegatedAccessLevel = (level: string = '') =>
	DELEGATED_ACCESS_LEVEL_LABELS[level as DelegatedAccessLevel] ?? ''
